import { useState, useEffect } from 'react';
import Router from 'next/router';
import Countdown from 'react-countdown';
import useSound from 'use-sound';
import Button from '@mui/material/Button';
import PauseIcon from '@mui/icons-material/Pause';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import TimePicker from 'components/otimepicker/withdropdown';
import TimePickerSimple from 'components/otimepicker/timepicker';
import { v4 as uuidv4 } from 'uuid';
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import moment from 'moment';
import { extendMoment } from 'moment-range';
const _moment = extendMoment(moment);
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DangerousIcon from '@mui/icons-material/Dangerous';
import DialogTitle from '@mui/material/DialogTitle';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import AccessAlarmSharpIcon from '@mui/icons-material/AccessAlarmSharp';
import LoopIcon from '@mui/icons-material/Loop';
import { useTranslations } from 'next-intl';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Snackbar from '@mui/material/Snackbar';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { timersState } from 'store/atoms';
import Select, { components } from "react-select";
import Alert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';


const sounds = [{
    value: 'alarm_fast_high.mp3',
    label: 'Fast high',

}, {
    value: 'iphone_alarm.mp3',
    label: 'Alarm',
}];

const NoOptionsMessage = props => {
    return (
        <components.NoOptionsMessage {...props}>
            <span className="custom-css-class">{t('key_not_found')}</span>
        </components.NoOptionsMessage>
    );
};


const ClearInd = () => (<svg style={{ cursor: "pointer" }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.46 7L14 12.54V14H12.54L7 8.46L1.46 14H0V12.54L5.54 7L0 1.46V0H1.46L7 5.54L12.54 0H14V1.46L8.46 7Z" fill="#444D67" />
</svg>);
const ClearIndicator = (props) => {
    const {
        children = <ClearInd />,
        getStyles,
        innerProps: { ref, ...restInnerProps },
    } = props;
    return (
        <div
            {...restInnerProps}
            ref={ref}
            style={getStyles('clearIndicator', props)}
        >
            <div style={{ padding: '0px 5px' }}>{children}</div>
        </div>
    );
};





const DropdownIndicator = props => {
    if (!props.hasValue && !props.selectProps.menuIsOpen) {
        return (
            <components.DropdownIndicator {...props} >
                <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0L5 5L10 0H0Z" fill="#152141" />
                </svg>
            </components.DropdownIndicator>

        )
    }
    if (!props.hasValue && props.selectProps.menuIsOpen) {
        return (
            <components.DropdownIndicator {...props} >
                <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 5L5 -4.37114e-07L0 5L10 5Z" fill="#444D67" />
                </svg>
            </components.DropdownIndicator>
        )
    }
    return null

};



export default function Main({ _timer, cancelDisplay, index, fullscreenfn = null, exrtaProps, timerObj, alreadyAdded, singleTimer }) {

    const predefined = {
        timer: _timer ? Date.now() + _timer : Date.now(),
        datetime: _timer ? moment().set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
        }).add(_timer, 'millisecond').format() : null,
        datetimer: timerObj?.datetimer,
        initial: _timer ? _timer : 0,
        title: timerObj?.title || 'Timer',
        times: timerObj?.times || null,
        timepickerDefault: timerObj?.timepickerDefault || {
            hours: 0,
            minutes: 0,
            seconds: 0
        }

    };

    const [timepickerDefault, setTimepickerDefault] = useState(predefined.timepickerDefault);
    const [title, setTitle] = useState(predefined.title);
    const [openmore, setOpenmore] = useState(false);
    const [openAlert, setOpenAlert] = useState(true);
    const [playing, setPlaying] = useState({});
    const [previewAudio, setPreviewAudio] = useState(null);
    const [sound, setSound] = useState(null);
    const [times, setTimes] = useState(predefined.times);
    const [radiovalue, setRadiovalue] = useState('cntd');

    const [alarmset, setAlarmset] = useState(false);
    const [timer, setTimer] = useState(predefined.timer);
    const [datetimer, setDatetimer] = useState(predefined.datetimer ? predefined.datetimer : predefined.timer);
    const [datetime, setDatetime] = useState(predefined.datetime);
    const [initial, setInitial] = useState(predefined.initial);
    const [openAlarm, setOpenAlarm] = useState(false);
    const [repeated, setRepeated] = useState(false);
    const timers = useRecoilValue(timersState);
    const setTimers = useSetRecoilState(timersState);
    const [mounted, setMounted] = useState(false);

    const [started, setStarted] = useState(false);
    const [error, setError] = useState(false);
    const [countdownApi, setCountdownApi] = useState(null);
    const [play, { stop }] = useSound('/iphone_alarm.mp3');
    const t = useTranslations();
    const commonTimes = [{
        id: '1',
        name: t("1 mins")
    }, {
        id: 2,
        name: t("2 mins")
    }, {
        id: 5,
        name: t("5 mins")
    }, {
        id: 10,
        name: t("10 mins")
    }, {
        id: 15,
        name: t("15 mins")
    }, {
        id: 20,
        name: t("20 mins")
    }, {
        id: 30,
        name: t("30 mins")
    }, {
        id: 60,
        name: t("60 mins")
    }];


    useEffect(() => {
        setMounted(true);
        if (countdownApi && countdownApi.isCompleted()) {
            countdownApi.start()
        };

    }, [repeated, countdownApi]);



    const setTimerInStorage = (started = false) => {
        try {


            let data_2_set = {
                id: uuidv4(),
                type: radiovalue,
                timepickerDefault: timepickerDefault,
                times: times,
                title: title,
                sound: sound,
                started: started,
                completed: false
            }



            const hrs = timepickerDefault.hours * 60 * 60 * 1000;
            const mins = timepickerDefault.minutes * 60 * 1000;
            const sec = timepickerDefault.seconds * 1000;
            const total_in_ms_timepickerDefault = _moment.range(moment(), moment().add(hrs + mins + sec, 'milliseconds')).diff();
            let total_in_ms_raw = times ? times * 60 * 1000 : total_in_ms_timepickerDefault;// 0.20 *
            let total_in_ms = moment().add(total_in_ms_raw, 'milliseconds').valueOf();
            if (radiovalue === 'cntdtill') {
                const preparedDatetimer = moment(datetimer).set({
                    hour: timepickerDefault.hours,
                    minute: timepickerDefault.minutes,
                    second: timepickerDefault.seconds
                });
                total_in_ms = preparedDatetimer.valueOf();
                total_in_ms_raw = _moment.range(moment(), preparedDatetimer).diff()

            }
            let datetimer_ms;
            if (datetimer && radiovalue === 'cntdtill') {
                console.log("=====datetimer====", datetimer);
                datetimer_ms = moment(datetimer).set({
                    hour: timepickerDefault.hours,
                    minute: timepickerDefault.minutes,
                    second: timepickerDefault.seconds
                }).valueOf();
                if (datetimer_ms < moment().valueOf()) {
                    throw new Error('Date must not be in the past')
                }
            }
            const total_in_ms_raw_left = total_in_ms_raw;
            data_2_set = {
                ...data_2_set,
                total_in_ms,
                total_in_ms_raw,
                total_in_ms_raw_left,
                datetimer: datetimer_ms
            };

            //If timer has id then need to update otherwise create new timer
            if (timerObj?.id) {
                setTimers([...(timers ? timers.map(v => {
                    if (v.id === timerObj?.id) {
                        delete data_2_set.id;
                        return {
                            ...v,
                            ...data_2_set
                        }
                    } else {
                        return v
                    }
                }) : [])]);
            } else {
                setTimers([data_2_set, ...(timers ? timers : [])]);
            }

            cancelDisplay && cancelDisplay();
            // Router.reload(window.location.pathname);
            return false;

        } catch (error) {
            if (error.message === 'Date must not be in the past') {
                alert(error.message);
            }
            //console.error(error);
        }


    }

    const ifAllowedToSave = () => {
        const is_timeset = timepickerDefault.hours || timepickerDefault.minutes || timepickerDefault.seconds;
        const is_times = !!times;
        const is_datetimer = !!datetimer;
        return is_timeset || is_times || is_datetimer;
    };

    const handleTimes = (event, newTimes) => {
        const ms = newTimes * 60 * 1000;
        const need_2_update = moment().set({
            milliseconds: 0,

        }).add(newTimes, 'minute').valueOf();
        setTimepickerDefault({
            hours: 0,
            minutes: 0,
            seconds: 0
        });
        setDatetime(Date.now() + newTimes * 60 * 1000);
        setTimes(newTimes);
        setTimer(need_2_update);
    }

    const timepickerCb = (tpdata) => {
        setTimes(null);


        setTimepickerDefault({
            hours: tpdata?.hours || 0,
            minutes: tpdata?.minutes || 0,
            seconds: tpdata?.seconds || 0
        });
    };

    const handleRadio = (e) => {
        setRadiovalue(e.target.value);
    }

    const handleSound = (sound) => {
        setSound(sound);
    };

    const setTimerForm = () => {
        setOpenmore(!openmore);
    }


    const handleClose = (event, reason) => {
        setAlarmset(false);
    };
    const handlePlay = (audio = null, action = 'play', index) => {
        try {
            previewAudio = audio ? audio : previewAudio;
            // const audio = new Audio('/iphone_alarm.mp3');
            if (action === 'play' && previewAudio) {
                setPlaying({
                    ...playing,
                    [index]: true
                })
                setPreviewAudio(audio);
                previewAudio.play();

            }

            if (action === 'stop' && previewAudio) {
                setPlaying({
                    ...playing,
                    [index]: false
                })
                previewAudio.pause();

            }
        } catch (error) {

        }
    }
    const handleTitle = (e) => {
        setTitle(e.target.value);
    }


    const start = () => {
        setStarted(true);
        countdownApi && countdownApi.start();
    };

    const stopTimer = () => {
        setStarted(false);
        countdownApi && countdownApi.stop();
    };
    const pause = () => {
        countdownApi && countdownApi.pause();
    };


    const handlePause = (e) => {
        setStarted(false);
        setTimer(Date.now() + e.total);
    }
    const handleStop = (e) => {
        setStarted(false);
        setTimer(Date.now() + initial);
    }

    const reset = () => {
        setTimer(Date.now() + initial);
    };

    const closeAlarmModal = () => {
        stop();
        setOpenAlarm(false);
        setStarted(false);
        setInitial(0);
    };

    const setRef = (countdown) => {
        if (countdown) {
            setCountdownApi(countdown.getApi());
        }
    }

    const complete = (e) => {

        setStarted(false);
        //setTimer(Date.now());
        setRepeated(false);
        setOpenAlarm(true);
        play();

        console.log("completed");
    };
    const repeat = () => {
        stop();
        setRepeated(true);
        setStarted(true);
        setOpenAlarm(false);
        setTimer(Date.now() + initial);
    };



    return (
        <>
            <div className='w-100' >
                {started && <Countdown key={`timer_key_${index ? index : 0}`} daysInHours={true} className='digital_clock_style ' ref={setRef} date={timer} onPause={handlePause} onStop={handleStop} onComplete={complete} autoStart={false} />}
                {radiovalue === 'cntd' && <span className="digital_clock_style ">{`${times > 59 ? '01' : '00'}:${times && times < 60 ? times.toString().length < 2 ? `0${times}` : times : '00'}:00 `}</span>}

                {radiovalue !== 'cntdtill' && <div className="common-times m-top-20">
                    <ToggleButtonGroup
                        exclusive={true}
                        value={times}
                        className={exrtaProps?.toggleclass ? exrtaProps?.toggleclass : ''}
                        onChange={handleTimes}
                        aria-label="text formatting"
                    >
                        {commonTimes.map((v, i) => {
                            return (<ToggleButton value={v.id} key={i} aria-label={v.name}>
                                {v.name}
                            </ToggleButton>)
                        })}
                    </ToggleButtonGroup>
                </div>}
                {!exrtaProps?.fromdialog && <div className="right-operations">

                    <div className="circle" title={t('Fullscreen')} onClick={fullscreenfn && fullscreenfn.enter}>
                        {(<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.166504 0.166992H4.33317V1.83366H1.83317V4.33366H0.166504V0.166992ZM7.6665 0.166992H11.8332V4.33366H10.1665V1.83366H7.6665V0.166992ZM10.1665 7.66699H11.8332V11.8337H7.6665V10.167H10.1665V7.66699ZM4.33317 10.167V11.8337H0.166504V7.66699H1.83317V10.167H4.33317Z" fill="#444D67" />
                        </svg>

                        )}
                    </div>
                </div>}

                <div>

                    {openmore && <div className="addTimer">
                        {true && <>
                            <h2>{t('Set a timer')}</h2>

                            <FormControl className='m-bottom-20 flex-form'>
                                <div className='title for-timer-title'>
                                    <h5>{t('Select type')}</h5>
                                </div>
                                <div className='field timer-field'>
                                    <RadioGroup
                                        row
                                        onChange={handleRadio}
                                        value={radiovalue}
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        defaultValue="countdown"
                                        name="radio-buttons-group"
                                        className='key_select_type'
                                    >
                                        <FormControlLabel value="countdown" control={<Radio value={'cntd'} sx={{
                                            color: "rgb(3, 201, 215)",
                                            '&.Mui-checked': {
                                                color: "rgb(3, 201, 215)",
                                            },
                                        }} />} label={t('Countdown')} />
                                        <FormControlLabel value="countdowntill" control={<Radio value={'cntdtill'} sx={{
                                            color: "rgb(3, 201, 215)",
                                            '&.Mui-checked': {
                                                color: "rgb(3, 201, 215)",
                                            },
                                        }} />} label={t('Count till (from) date')} />

                                    </RadioGroup>
                                </div>
                            </FormControl>
                            <FormControl color="error" className='m-bottom-20 flex-form' variant="standard">
                                <div className='title'>
                                    <h5>{t('Set a title')}</h5>
                                </div>
                                <div className='field'>
                                    <TextField
                                        color="error"
                                        className="text-input text-input-timer"
                                        value={title}
                                        onChange={handleTitle}
                                    />
                                </div>
                            </FormControl>
                            <FormControl className='m-bottom-20 flex-form' variant="standard">
                                <div className='title for-timer-title'>
                                    <h5>{t('Set a time(date)')}</h5>
                                </div>
                                <div className='field timer-field'>
                                    {radiovalue === 'cntdtill' && <> <FormControl className=' flex-form datepicker-input w-100' variant="standard">
                                        {/*<div className='title'>
                                            <h5>{t('Set a date')}</h5>
                                        </div>*/}
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                disablePast
                                                inputFormat="dd.MM.yyyy"
                                                value={datetimer}
                                                onChange={(newValue) => {
                                                    setDatetimer(newValue);
                                                }}
                                                components={{
                                                    OpenPickerIcon: () => (<svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M3.83333 9.16634H5.5V10.833H3.83333V9.16634ZM15.5 4.16634V15.833C15.5 16.758 14.7583 17.4997 13.8333 17.4997H2.16667C1.24167 17.4997 0.5 16.7497 0.5 15.833V4.16634C0.5 3.24967 1.25 2.49967 2.16667 2.49967H3V0.833008H4.66667V2.49967H11.3333V0.833008H13V2.49967H13.8333C14.7583 2.49967 15.5 3.24967 15.5 4.16634ZM2.16667 5.83301H13.8333V4.16634H2.16667V5.83301ZM13.8333 15.833V7.49967H2.16667V15.833H13.8333ZM10.5 10.833V9.16634H12.1667V10.833H10.5ZM7.16667 10.833V9.16634H8.83333V10.833H7.16667ZM3.83333 12.4997H5.5V14.1663H3.83333V12.4997ZM10.5 14.1663V12.4997H12.1667V14.1663H10.5ZM7.16667 14.1663V12.4997H8.83333V14.1663H7.16667Z" fill="#152141" />
                                                    </svg>)
                                                }}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                        <TimePicker key={'TimePicker-key-1'} notitle={true} timepickerDefault={timepickerDefault} onchangeTimer={timepickerCb} />
                                    </>}
                                    {radiovalue === 'cntd' && <>
                                        <TimePicker key={'TimePicker-key-2'} notitle={true} timepickerDefault={timepickerDefault} onchangeTimer={timepickerCb} am_pm={false} />
                                        {/* <TimePickerSimple onChange={timepickerCb} />*/}
                                    </>}
                                </div>
                            </FormControl>

                            <FormControl className='m-bottom-20 flex-form' variant="standard">
                                <div className='title'>
                                    <h5>{t('Choose a sound')}</h5>
                                </div>
                                <div className='field'>
                                    <FormControl className='sound-container'>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            className={"simple-select"}
                                            classNamePrefix="simple-select"
                                            placeholder={t('Choose a sound')}
                                            id={"simple-select-id"}
                                            instanceId={"simple-select-id"}
                                            value={sound}
                                            components={{
                                                NoOptionsMessage,
                                                ClearIndicator,
                                                DropdownIndicator,
                                                IndicatorSeparator: () => null
                                            }}
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 0,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: 'rgb(3, 201, 215)',
                                                    primary: 'rgb(3, 201, 215)',
                                                },
                                            })}

                                            options={sounds}
                                            isClearable={true}
                                            onError={() => { console.log("error") }}
                                            onErrorCapture={() => { console.log("error") }}
                                            onKeyDown={(params) => { }}
                                            onChange={handleSound}

                                            styles={{
                                                noOptionsMessage: base => {

                                                    return { ...base, color: "red" }
                                                },

                                                menuList: (base) => ({
                                                    ...base,
                                                    "::-webkit-scrollbar-track": {
                                                        background: "white"
                                                    },
                                                    "::-webkit-scrollbar-thumb": {
                                                        background: "#60B475"
                                                    },
                                                    "::-webkit-scrollbar-thumb:hover": {
                                                        background: "#60B475"
                                                    }
                                                })
                                            }}
                                        >

                                        </Select>
                                        {sound && <div className='sound-buttons'>
                                            {!playing[sound.value] && <div onClick={() => { handlePlay(new Audio(`/` + sound.value), 'play', sound.value) }} className='play-button operation-button'>
                                                <svg width="30" height="30" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 0C8.68678 0 7.38642 0.258658 6.17317 0.761205C4.95991 1.26375 3.85752 2.00035 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM8 14.5L14 10L8 5.5V14.5Z" fill="#E8E9EC" />
                                                </svg>
                                            </div>}
                                            {playing[sound.value] && <div onClick={() => { handlePlay(null, 'stop', sound.value) }} className='stop-button operation-button'>
                                                <svg width="30" height="30" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10 0C8.68678 0 7.38642 0.258658 6.17317 0.761205C4.95991 1.26375 3.85752 2.00035 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2ZM7 7V13H13V7" fill="#E8E9EC" />
                                                </svg>
                                            </div>}
                                        </div>}
                                    </FormControl>
                                </div>
                            </FormControl>
                            {/* <FormControl className='m-bottom-20 flex-form' variant="standard">
                                <div className='title'>
                                    <h5>{t('Choose a sound')}</h5>
                                </div>
                                <div className='field'>
                                    <div className='toglelike'>
                                        {sounds.map((v, i) => {
                                            return (<div className={sound === v.key ? 'toglelike-inner  selected-inner' : "toglelike-inner"} key={i}><div className={sound === v.key ? 'toggle-like-each selected' : 'toggle-like-each '} onClick={() => { handleSound(v.key) }} value={v.key} aria-label={v.name}>
                                                {v.name}
                                            </div>
                                                {v.key && <div>
                                                    {!playing[i] && <div onClick={() => { handlePlay(new Audio(`/` + v.key), 'play', i) }} className='play-button operation-button'>
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 0C8.68678 0 7.38642 0.258658 6.17317 0.761205C4.95991 1.26375 3.85752 2.00035 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM8 14.5L14 10L8 5.5V14.5Z" fill="#E8E9EC" />
                                                        </svg>
                                                    </div>}
                                                    {playing[i] && <div onClick={() => { handlePlay(null, 'stop', i) }} className='stop-button operation-button'>
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M10 0C8.68678 0 7.38642 0.258658 6.17317 0.761205C4.95991 1.26375 3.85752 2.00035 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2ZM7 7V13H13V7" fill="#E8E9EC" />
                                                        </svg>
                                                    </div>}
                                                </div>}
                                            </div>)
                                        })}
                                    </div>
                                </div>
                            </FormControl>*/}
                        </>}
                        <FormControl className='m-bottom-20 flex-form key_set_timer_div' variant="standard">
                            <div className='title'></div>
                            <div className={radiovalue === 'cntd' ? 'field key_set_timer' : 'field key_set_timer_left '}>
                                <div className={ifAllowedToSave() ? "btn-div" : "btn-div disabled-btn-div"}>
                                    <Button variant="contained" onClick={() => setTimerInStorage(true)}  >
                                        {t('Start')}
                                    </Button>
                                </div>
                                {radiovalue === 'cntd' && <div className='btn-div  snooze-btn-div'>
                                    <Button variant="outlined" onClick={() => setTimerInStorage()} disabled={started} className="m-right-15 " >
                                        {t('Set timer ')}
                                    </Button>
                                </div>}

                                {radiovalue === 'cntd' && <div className='btn-div error-btn-div'>
                                    <Button color="error" onClick={setTimerForm} disabled={started} className="m-right-15 " >
                                        {t('Cancel')}
                                    </Button>
                                </div>}

                            </div>
                        </FormControl>
                        <Snackbar
                            open={alarmset}
                            autoHideDuration={5000}
                            message={t('Timer set!')}
                            onClose={handleClose}
                        />
                    </div>}
                    <div className='d-flex'>
                        {times && !openmore && <div className='sub-operations'>
                            <div className="btn-div">
                                <Button variant="contained" onClick={() => setTimerInStorage(true)}  >
                                    {t('Start')}
                                </Button>
                            </div>
                            <div className=' btn-div disabled-btn-div' >
                                <Button variant="contained" onClick={reset} className="" >
                                    {t('Reset')}
                                </Button>
                            </div>
                        </div>}
                        {/*!openmore && <div className='timer-btn-info'>
                            <span>{t('Use a preset or set a timer manually')}</span>
                        </div>*/}
                        {(!times && !openmore && !alreadyAdded) && <div className={'btn-div'}>
                            <Button variant="outlined" onClick={setTimerForm} className="m-right-15 " >
                                {t('Set timer ')}
                            </Button>
                        </div>}
                        {times && !openmore && !alreadyAdded && <div className={'btn-div'}>
                            <Button variant="outlined" onClick={setTimerForm} className="trans-bg " >
                                {t('Set timer ')}
                            </Button>
                        </div>}
                        {alreadyAdded && !openmore && <div className={'btn-div  already-added-div'}>
                            <Button variant="outlined" onClick={setTimerForm} className="trans-bg" >
                                {t('Add Another Timer')}
                            </Button>
                        </div>}

                    </div>


                    {started && <Button variant="outlined" onClick={pause} disabled={!started} className="m-right-15" startIcon={<PauseIcon color="warning" />}>
                        {t('Pause')}
                    </Button>}
                    {started && <Button variant="outlined" onClick={stopTimer} className="m-right-15" startIcon={<DangerousIcon color="error" />}>
                        {t('Stop')}
                    </Button>}

                </div>
            </div>
            <Dialog open={openAlarm} onClose={closeAlarmModal}>
                <DialogTitle style={{ textAlign: "center" }}> {t('Timer alarm')}</DialogTitle>
                <DialogContent className="m-w-250">
                    <div style={{ textAlign: "center" }}>
                        <AccessAlarmSharpIcon fontSize="large" color="error" />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={repeat} className="m-right-15" startIcon={<LoopIcon />}>
                        {t('Repeat')}
                    </Button>
                    <Button onClick={closeAlarmModal}> {t('Close')} </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

